import styled from 'styled-components';
import { Avatar, Progress, Button, Skeleton } from 'antd';
import { ClockCircleOutlined, EyeOutlined, FileDoneOutlined } from '@ant-design/icons';
import { getDateTime } from '../../utils';
import { getSize, Heading4, SecondaryText, SupportText, getColor, primitives, styleVariables, SecondaryButton, HeightSpacer } from '@lib/common';
import { AttendeeSubmissionStatusComponent, getAttendeeSubmissionExpiryTime, getTranslatedSubmissionStatusKey, isAttendeeSubmissionCountingDown } from '../../attendee-submission-status';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var md5 = function md5(str) {
  var hash = 0;

  for (var i = 0; i < str.length; i++) {
    var _char = str.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash = hash & hash;
  }

  return Math.abs(hash).toString(16);
};

var getSubmissionStatusTranslationName = function getSubmissionStatusTranslationName(attendeeTranslation, attendee, currentTimeMs, isAssignmentEnded) {
  var _ref, _attendeeTranslation$, _attendeeTranslation$2, _attendeeTranslation$3;

  var submissionStatusTranslationKeys = {
    submissionStatusOnGoing: attendeeTranslation.statusOnGoing,
    submissionStatusPaused: attendeeTranslation.statusPaused,
    submissionStatusBanned: attendeeTranslation.statusBanned,
    submissionStatusPassed: attendeeTranslation.passed,
    submissionStatusFailed: attendeeTranslation.failed,
    submissionStatusSubmitted: (_ref = (_attendeeTranslation$ = attendeeTranslation.submissionStatusSubmitted) !== null && _attendeeTranslation$ !== void 0 ? _attendeeTranslation$ : attendeeTranslation.statusSubmitted) !== null && _ref !== void 0 ? _ref : '',
    submissionStatusExpired: (_attendeeTranslation$2 = attendeeTranslation.statusExpired) !== null && _attendeeTranslation$2 !== void 0 ? _attendeeTranslation$2 : 'Not submitted',
    submissionStatusNone: (_attendeeTranslation$3 = attendeeTranslation.statusNotStarted) !== null && _attendeeTranslation$3 !== void 0 ? _attendeeTranslation$3 : ''
  };
  return submissionStatusTranslationKeys[getTranslatedSubmissionStatusKey(attendee, currentTimeMs, isAssignmentEnded)];
};

var StyledCardWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledCardWrapper",
  componentId: "sc-hn6l0e-0"
})(["background:", ";border-radius:", ";border:1px solid ", ";padding:24px;display:flex;align-items:center;gap:20px;margin-bottom:16px;transition:box-shadow 0.3s ease;@media (max-width:576px){", "}&:hover{box-shadow:0 4px 12px rgba(0,0,0,0.15);}"], getColor('fillBgWhite'), getSize('radiusSm'), styleVariables.colors.gray9, function (_ref2) {
  var $hasCloseActions = _ref2.$hasCloseActions;
  return $hasCloseActions && "\n      flex-direction: column;\n      align-items: stretch;\n      overflow-wrap: anywhere;\n      > div { min-width: 0; }\n      > div:last-child { width: 100%; }\n      > div:last-child > div { width: 100%; }\n    ";
});
var StyledWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledWrapper",
  componentId: "sc-hn6l0e-1"
})(["display:flex;flex-direction:column;align-items:center;gap:12px;"]);
var StyledAboveWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledAboveWrapper",
  componentId: "sc-hn6l0e-2"
})(["display:flex;align-items:center;justify-content:center;flex:1;"]);
var StyledInfoSection = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledInfoSection",
  componentId: "sc-hn6l0e-3"
})(["flex:1;display:flex;flex-direction:column;"]);
var StyledName = styled(Heading4).withConfig({
  displayName: "attendee-cardcomponent__StyledName",
  componentId: "sc-hn6l0e-4"
})([""]);
var StyledEmail = styled(SecondaryText).withConfig({
  displayName: "attendee-cardcomponent__StyledEmail",
  componentId: "sc-hn6l0e-5"
})([""]);
var StyledTimeStamp = styled(SupportText).withConfig({
  displayName: "attendee-cardcomponent__StyledTimeStamp",
  componentId: "sc-hn6l0e-6"
})(["display:flex;align-items:center;gap:6px;.anticon{font-size:", ";}"], getSize('typo14'));
var StyledRemainingTime = styled(StyledTimeStamp).withConfig({
  displayName: "attendee-cardcomponent__StyledRemainingTime",
  componentId: "sc-hn6l0e-7"
})(["color:", ";font-weight:600;"], styleVariables.colors.blue6);
var StyledScoreSection = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledScoreSection",
  componentId: "sc-hn6l0e-8"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;"]);
var StyledViolationAction = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledViolationAction",
  componentId: "sc-hn6l0e-9"
})([".ant-btn{height:auto;padding:0;}"]);
var StyledScoreLabel = styled(SupportText).withConfig({
  displayName: "attendee-cardcomponent__StyledScoreLabel",
  componentId: "sc-hn6l0e-10"
})(["text-transform:uppercase;letter-spacing:1px;"]);
var StyledScoreValue = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledScoreValue",
  componentId: "sc-hn6l0e-11"
})(["font-size:", ";font-weight:700;color:", ";"], getSize('typo24'), getColor('fillIntActive'));
var StyledGradingSection = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledGradingSection",
  componentId: "sc-hn6l0e-12"
})(["display:flex;flex-direction:column;align-items:center;min-width:180px;border-left:1px solid ", ";padding-left:16px;"], getColor('fillIntSubActive'));
var StyledSubmissionActions = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledSubmissionActions",
  componentId: "sc-hn6l0e-13"
})(["display:flex;flex-direction:column;gap:12px;width:100%;margin-top:16px;> button{width:100%;}@media (max-width:576px){> button{white-space:normal;height:auto;min-height:40px;}}"]);
var StyledProgressWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledProgressWrapper",
  componentId: "sc-hn6l0e-14"
})(["display:flex;align-items:center;gap:12px;"]);
var GradingLabel = styled(SupportText).withConfig({
  displayName: "attendee-cardcomponent__GradingLabel",
  componentId: "sc-hn6l0e-15"
})(["text-transform:uppercase;letter-spacing:1px;margin-bottom:8px;"]);
var StyledProgressBar = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledProgressBar",
  componentId: "sc-hn6l0e-16"
})(["width:120px;margin-bottom:4px;"]);
var StyledPercentageText = styled(SecondaryText).withConfig({
  displayName: "attendee-cardcomponent__StyledPercentageText",
  componentId: "sc-hn6l0e-17"
})(["font-weight:600;color:", ";"], function (props) {
  return props.color || primitives.green[5];
});

var buttonTextGradingOrReview = function buttonTextGradingOrReview(attendee, attendeeTranslation) {
  if (attendee.report.gradedPercentage < 100) {
    return attendeeTranslation.attendeeNeedToBeGrading;
  } else {
    return attendeeTranslation.attendeeNeedToReview;
  }
};

var formatRemainingTime = function formatRemainingTime(remainingSeconds) {
  var hours = Math.floor(remainingSeconds / 3600);
  var minutes = Math.floor(remainingSeconds % 3600 / 60);
  var seconds = remainingSeconds % 60;
  return [hours, minutes, seconds].map(function (unit) {
    return String(unit).padStart(2, '0');
  }).join(':');
};

export var AttendeeCard = function AttendeeCard(_ref3) {
  var _attendee$report, _attendeeTranslation$4, _attendeeTranslation$5, _report$score;

  var attendee = _ref3.attendee,
      onOpenAttendeeSubmission = _ref3.onOpenAttendeeSubmission,
      onCloseSubmission = _ref3.onCloseSubmission,
      onOpenViolateDetailModal = _ref3.onOpenViolateDetailModal,
      isReloading = _ref3.isReloading,
      attendeeTranslation = _ref3.attendeeTranslation,
      assignmentDuration = _ref3.assignmentDuration,
      _ref3$hideGradingStat = _ref3.hideGradingStatus,
      hideGradingStatus = _ref3$hideGradingStat === void 0 ? false : _ref3$hideGradingStat,
      _ref3$isGradingInProg = _ref3.isGradingInProgress,
      isGradingInProgress = _ref3$isGradingInProg === void 0 ? false : _ref3$isGradingInProg,
      gradingAttendeeId = _ref3.gradingAttendeeId,
      _ref3$currentTimeMs = _ref3.currentTimeMs,
      currentTimeMs = _ref3$currentTimeMs === void 0 ? Date.now() : _ref3$currentTimeMs,
      _ref3$isAssignmentEnd = _ref3.isAssignmentEnded,
      isAssignmentEnded = _ref3$isAssignmentEnd === void 0 ? false : _ref3$isAssignmentEnd,
      _ref3$isPractice = _ref3.isPractice,
      isPractice = _ref3$isPractice === void 0 ? false : _ref3$isPractice;
  var name = "".concat(attendee.firstName, " ").concat(attendee.lastName);
  var email = attendee.email || 'No email provided';
  var report = attendee.report;
  var normalizedSubmitTime = report.submitTime == null ? '' : String(report.submitTime).trim();
  var submitTime = Number(normalizedSubmitTime);
  var hasSubmitTime = normalizedSubmitTime.length > 0 && Number.isFinite(submitTime) && submitTime > 0;
  var canViewViolation = Boolean(onOpenViolateDetailModal) && ((_attendee$report = attendee.report) === null || _attendee$report === void 0 ? void 0 : _attendee$report.isViolatedSecurityOptions);
  var timeTakenMinutes = typeof assignmentDuration === 'number' ? report.getTimeTakenMinutes(assignmentDuration) : null;
  var avatarUrl = attendee.email ? "https://www.gravatar.com/avatar/".concat(md5(attendee.email), "?d=identicon") : undefined;
  var isCurrentAttendeeBeingGraded = isGradingInProgress && gradingAttendeeId === attendee.id.toString();

  var getProgressColor = function getProgressColor(percentage) {
    if (percentage === 100) return '#52c41a';
    if (percentage >= 75) return '#1890ff';
    if (percentage >= 50) return '#faad14';
    return '#ff4d4f';
  };

  var progressColor = getProgressColor(report.gradedPercentage || 0);
  var expiryTime = getAttendeeSubmissionExpiryTime(attendee);
  var shouldShowCountdown = !isAssignmentEnded && isAttendeeSubmissionCountingDown(attendee, currentTimeMs);
  var remainingSeconds = expiryTime == null ? 0 : Math.max(0, Math.ceil((expiryTime - currentTimeMs) / 1000));

  if (isReloading) {
    return /*#__PURE__*/_jsxs(StyledCardWrapper, {
      $hasCloseActions: !!onCloseSubmission,
      children: [/*#__PURE__*/_jsx(Skeleton.Avatar, {
        active: true,
        size: 64,
        shape: "circle"
      }), /*#__PURE__*/_jsxs(StyledInfoSection, {
        style: {
          flex: 1
        },
        children: [/*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '50%',
            marginBottom: 8
          }
        }), /*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '30%'
          }
        })]
      }), /*#__PURE__*/_jsxs(StyledWrapper, {
        style: {
          flex: 1,
          alignItems: 'flex-start'
        },
        children: [/*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '80px',
            marginBottom: 12
          }
        }), /*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '120px'
          }
        })]
      })]
    });
  }

  var closeActions = onCloseSubmission ? /*#__PURE__*/_jsxs(StyledSubmissionActions, {
    children: [/*#__PURE__*/_jsx(SecondaryButton, {
      icon: /*#__PURE__*/_jsx(FileDoneOutlined, {}),
      onClick: function onClick() {
        return onCloseSubmission(attendee);
      },
      children: attendeeTranslation.closeSubmission
    }), onOpenAttendeeSubmission && /*#__PURE__*/_jsxs(SecondaryButton, {
      onClick: function onClick() {
        return onOpenAttendeeSubmission(attendee);
      },
      children: [/*#__PURE__*/_jsx(EyeOutlined, {}), attendeeTranslation.clickToViewDetail]
    })]
  }) : null;
  return /*#__PURE__*/_jsxs(StyledCardWrapper, {
    $hasCloseActions: !!onCloseSubmission,
    children: [/*#__PURE__*/_jsx(Avatar, {
      size: 64,
      src: avatarUrl,
      children: name === null || name === void 0 ? void 0 : name.charAt(0)
    }), /*#__PURE__*/_jsxs(StyledInfoSection, {
      children: [/*#__PURE__*/_jsx(StyledName, {
        children: name
      }), /*#__PURE__*/_jsx(StyledEmail, {
        children: email
      }), hasSubmitTime && /*#__PURE__*/_jsxs(StyledTimeStamp, {
        children: [/*#__PURE__*/_jsx(ClockCircleOutlined, {}), getDateTime(submitTime)]
      }), canViewViolation && /*#__PURE__*/_jsx(StyledViolationAction, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "link",
          danger: true,
          onClick: function onClick() {
            return onOpenViolateDetailModal === null || onOpenViolateDetailModal === void 0 ? void 0 : onOpenViolateDetailModal(attendee);
          },
          children: attendeeTranslation.viewViolationDetails
        })
      }), timeTakenMinutes != null && timeTakenMinutes > 0 && /*#__PURE__*/_jsxs(StyledTimeStamp, {
        children: [attendeeTranslation.timeTaken, ": ", timeTakenMinutes, ' ', (_attendeeTranslation$4 = attendeeTranslation.minutesShort) !== null && _attendeeTranslation$4 !== void 0 ? _attendeeTranslation$4 : 'mins']
      }), shouldShowCountdown && /*#__PURE__*/_jsxs(StyledRemainingTime, {
        children: [/*#__PURE__*/_jsx(ClockCircleOutlined, {}), (_attendeeTranslation$5 = attendeeTranslation.timeRemaining) !== null && _attendeeTranslation$5 !== void 0 ? _attendeeTranslation$5 : 'Time remaining', ":", ' ', formatRemainingTime(remainingSeconds)]
      })]
    }), /*#__PURE__*/_jsx(StyledWrapper, {
      children: report.gradedPercentage ? /*#__PURE__*/_jsxs(StyledAboveWrapper, {
        style: hideGradingStatus && !onOpenAttendeeSubmission ? {
          justifyContent: 'flex-end'
        } : {},
        children: [/*#__PURE__*/_jsxs(StyledScoreSection, {
          children: [/*#__PURE__*/_jsx(StyledScoreLabel, {
            children: attendeeTranslation.score
          }), isCurrentAttendeeBeingGraded ? /*#__PURE__*/_jsx(Skeleton.Input, {
            active: true,
            style: {
              width: '60px',
              height: '32px'
            }
          }) : /*#__PURE__*/_jsx(StyledScoreValue, {
            children: ((_report$score = report.score) === null || _report$score === void 0 ? void 0 : _report$score.toFixed(1)) || null
          }), /*#__PURE__*/_jsx(HeightSpacer, {
            size: 12
          }), /*#__PURE__*/_jsx(AttendeeSubmissionStatusComponent, {
            attendee: attendee,
            text: getSubmissionStatusTranslationName(attendeeTranslation, attendee, currentTimeMs, isAssignmentEnded),
            currentTimeMs: currentTimeMs,
            isAssignmentEnded: isAssignmentEnded,
            isPractice: isPractice
          })]
        }), (!hideGradingStatus || onOpenAttendeeSubmission || onCloseSubmission) && /*#__PURE__*/_jsxs(StyledGradingSection, {
          children: [!hideGradingStatus && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(GradingLabel, {
              children: attendeeTranslation.gradingStatus
            }), /*#__PURE__*/_jsxs(StyledProgressWrapper, {
              children: [isCurrentAttendeeBeingGraded ? /*#__PURE__*/_jsx(Skeleton.Input, {
                active: true,
                style: {
                  width: '120px',
                  height: '8px'
                }
              }) : /*#__PURE__*/_jsx(StyledProgressBar, {
                children: /*#__PURE__*/_jsx(Progress, {
                  percent: report.gradedPercentage || 0,
                  strokeColor: progressColor,
                  showInfo: false,
                  strokeWidth: 8
                })
              }), isCurrentAttendeeBeingGraded ? /*#__PURE__*/_jsx(Skeleton.Input, {
                active: true,
                style: {
                  width: '35px',
                  height: '14px'
                }
              }) : /*#__PURE__*/_jsxs(StyledPercentageText, {
                color: progressColor,
                children: [report.gradedPercentage || 0, "%"]
              })]
            })]
          }), closeActions !== null && closeActions !== void 0 ? closeActions : onOpenAttendeeSubmission && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(HeightSpacer, {
              size: 16
            }), /*#__PURE__*/_jsxs(SecondaryButton, {
              onClick: function onClick() {
                return onOpenAttendeeSubmission(attendee);
              },
              children: [/*#__PURE__*/_jsx(EyeOutlined, {}), attendeeTranslation.clickToViewDetail]
            })]
          })]
        })]
      }) : /*#__PURE__*/_jsx(StyledAboveWrapper, {
        children: /*#__PURE__*/_jsxs(StyledGradingSection, {
          children: [/*#__PURE__*/_jsx(GradingLabel, {
            children: attendeeTranslation.result
          }), /*#__PURE__*/_jsx(StyledProgressWrapper, {
            children: /*#__PURE__*/_jsx(AttendeeSubmissionStatusComponent, {
              attendee: attendee,
              text: getSubmissionStatusTranslationName(attendeeTranslation, attendee, currentTimeMs, isAssignmentEnded),
              currentTimeMs: currentTimeMs,
              isAssignmentEnded: isAssignmentEnded,
              isPractice: isPractice
            })
          }), closeActions !== null && closeActions !== void 0 ? closeActions : onOpenAttendeeSubmission && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(HeightSpacer, {
              size: 16
            }), /*#__PURE__*/_jsxs(SecondaryButton, {
              onClick: function onClick() {
                return onOpenAttendeeSubmission(attendee);
              },
              children: [/*#__PURE__*/_jsx(EyeOutlined, {}), attendeeTranslation.clickToViewDetail]
            })]
          })]
        })
      })
    })]
  });
};